module.exports = __webpack_public_path__ + "assets/svg-support.305423d2.svg";